import Vue from 'vue';
import VueRamda from 'vue-ramda';

Vue.use(VueRamda);

export default VueRamda;
